import * as OvationsApi from 'core/ovations-api';
import * as Enums from '../enums';

export const mockProfileField: OvationsApi.Types.ProfileField = {
    id: 10,
    key: 'Custom Field 1',
    label: 'New Custom Field 1',
    profileFieldType: Enums.ProfileFieldType.Custom,
};
